"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);
const isListItem = element => {
  const elementName = element?.type?.displayName || element?.type?.name;
  // Match our own ListItem, and also, custom list items
  return Boolean(elementName.match(/Item/));
};

/**
 * An unordered List component has a child a ListItem that
 * allows icon, dividers and customized typography
 */
const List = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    showDivider,
    tokens,
    variant,
    accessibilityRole = _Platform.default.select({
      web: 'list',
      default: undefined
    }),
    ...rest
  } = _ref;
  const items = _react.default.Children.map(children, (child, index) => {
    // Pass ListItem-specific props to children (by name so teams can add their own ListItems)
    if (isListItem(child)) {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        showDivider,
        isLastItem: index + 1 === _react.default.Children.count(children),
        tokens,
        variant,
        ...child.props
      });
    }
    return child;
  });
  const content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    style: styles.list,
    accessibilityRole: accessibilityRole,
    ref: ref,
    ...selectProps(rest),
    children: items
  });
  return _Platform.default.OS === 'web' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: styles.container,
    children: content
  }) : content;
});
const styles = _StyleSheet.default.create({
  container: {
    display: 'block'
  },
  list: {
    flex: 1,
    flexShrink: 1
  }
});
List.displayName = 'List';
List.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _utils.getTokensPropType)('List'),
  variant: _utils.variantProp.propType,
  children: _propTypes.default.node,
  /**
   * In case it is not the last item allow display divider
   */
  showDivider: _propTypes.default.bool
};
var _default = exports.default = List;